<!-- eslint-disable -->
<template>
  <div
    v-loading="loading"
    class="kr-table-by-gm"
    :kr-table-by-gm="gridManagerName"
    :style="tableData.length ? 'auto' : 'min-height: 300px'"
  >
    <grid-manager
      v-if="show && headerData.length"
      :option="gridOption"
      :callback="callback"
      :ref="gridManagerName"
    ></grid-manager>

    <el-tooltip
      ref="tooltip"
      placement="bottom"
      :visible-arrow="true"
    ></el-tooltip>
    <!--表格筛选-->
    <el-popover
      :reference="reference"
      :visibleArrow="false"
      :offset="0"
      v-model="filterPopVisible"
      @after-leave="popoverAfterLeave"
      popper-class="kr-table-filter-popper"
      placement="bottom-start"
      width="340"
      ref="popover"
    >
      <transition name="show">
        <div :key="filterForms.property" class="filterBox">
          <template v-if="filterForms.type && filterForms.type == 'DATE_RANGE'">
            <div class="btnGloupClass">
              <el-button
                @click="DateCateBtnTypeHandle(item.type)"
                size="mini"
                plain
                :type="isDateRangeType == item.type ? 'primary' : ''"
                v-for="item in DateCateBtnGroup"
                :key="item.type"
                >{{ item.name }}
              </el-button>
            </div>
          </template>
          <tableFilterForm
            :meta="filterForms"
            ref="filterForms"
            :value="filterValue"
          ></tableFilterForm>
          <div style="text-align: right; margin: 0;">
            <el-button
              :class="gridManagerName + '-kr-table-filter-reset'"
              size="mini"
              type="text"
              >清空</el-button
            >
            <el-button size="mini" @click="filterPopVisible = false"
              >取消</el-button
            >
            <el-button
              :class="gridManagerName + '-kr-table-filter-submit'"
              type="primary"
              size="mini"
              >确定</el-button
            >
          </div>
        </div>
      </transition>
    </el-popover>
    <Preview
      :visible.sync="previewDialog.visible"
      v-if="previewDialog.visible"
      v-bind="previewDialog"
      :title="previewDialog.title"
      :value="previewDialog.value"
      @exit="exitPreview"
      @download="downloadImg"
    >
    </Preview>

    <KrDialog
      v-if="viewFileDialog.visible"
      v-bind="viewFileDialog"
      :visible.sync="viewFileDialog.visible"
      append-to-body
    >
      <div class="file-content">
        <ViewFile v-bind="viewFileConfig" :max-height="400" />
      </div>
    </KrDialog>
  </div>
</template>

<script>
/*  eslint-disable */
import { mapState } from 'vuex';
import moment from 'moment'
import GridManager from 'jingdata-grid-manager-vue'
import KrDialog from '@c/components/KrDialog'
import 'jingdata-grid-manager-vue/css/gm-vue.css'
import krTableDataMixin from '../krTable/krTableDataMixin'
import { getColumnAlignByType, getColumnMinWidth } from '../krTable/columnAlign'
import {
  queryAllFileList,
  relatedDataByReference,
} from '@inv/services/metaData/module/edit'
import { getRecordTypeLayout } from '@inv/services/metaData/module/index'
import { globalVariableList } from '@inv/services/metaData/businessCustomization';
import krThByGm from './components/krThByGm'
import runTemplate from '@inv/components/metaData/krTable/runTemplate/index.js'
import TableStore from '@c/components/InsightDataTable/store.js'
import RelatedTable from './components/relatedTable'
import fields from '@inv/components/metaData/form/field/all';
import { Loading } from 'element-ui';
import blobDownLoad from '@c/utils/blobDownLoad';
import router from '@/router'
const IS_HTML_REGEXP = /<\/?[a-zA-Z]+(\s+[a-zA-Z]+=".*")*>/
const MOZ_HACK_REGEXP = /^moz([A-Z])/
const SPECIAL_CHARS_REGEXP = /([:-_]+(.))/g
const camelCase = function(name) {
  return name
    .replace(SPECIAL_CHARS_REGEXP, (_, separator, letter, offset) => {
      return offset ? letter.toUpperCase() : letter
    })
    .replace(MOZ_HACK_REGEXP, 'Moz$1')
}
const VIEW_CODES = ['all__system', 'in_charge__system', 'involved__system']

export default {
  componentName: 'krTableByGm',
  props: {
    headerData: kr.vue.getPropArray(),
    tableData: kr.vue.getPropArray(),
    isSingle: kr.vue.getPropBoolean(),
    tableProps: kr.vue.getPropObject({
      settingsType: 'dropdown',
      // forceSetHeader: false, //说实话真的不知道这个属性是干嘛的 只是为了兼容，并对当初添加这个属性的人表示鄙视。
      // showSetHeader: true,
    }),
    metaData: kr.vue.getPropObject(),
    settings: {
      type: [Array, String],
      default() {
        return []
      },
    },
    filterMetas: Object,
    queryAllFileList,
  },
  data() {
    return {
      loading: false,
      width: '100%',
      height: '100%',
      viewFileDialog: {
        visible: false,
        title: '文件汇总',
        width: '1176px',
      },
      Global_e4wl__global: null,
      viewFileConfig: {
        apiName: '',
        editShow: true,
        editflag: false,
        ele: 'file',
        id: '', // rowid
        value: {}, // rowdata
        jurisdiction: false, // auth
        obj: {
          value: {
            fileType: [],
          },
        },
        fileTableMetas: {
          api: queryAllFileList,
        },
      },
      tableStore: new TableStore('krTableByGm'),
      gridManagerName: `krTableByGm${kr.random.string_number()}`,
      show: false,
      reference: '',
      filterPopVisible: false,
      filterForms: {},
      filterPopEvent: '',
      currentFilterEvent: '',
      currentFilterProperty: '',
      filterValue: {},
      filterValues: {},
      tooltipContent: '',
      ...krTableDataMixin.data(),
      DateCateBtnGroup: [
        {
          name: '本周',
          type: 'week',
        },
        {
          name: '本月',
          type: 'month',
        },
        {
          name: '本季度',
          type: 'quarter',
        },
        {
          name: '本年',
          type: 'year',
        },
      ],
      DateRangeType: '',
      color: {
        1: 'red', 2: 'yellow', 3: 'blue', 4: 'green',
      },
      Global_qezq__global: false
    }
  },
  computed: {
    // viewFileConfig() {
    //   return {
    //     apiName: '',
    //     editShow:true,
    //     editflag:false,
    //     ele:"file",
    //     id: '', // rowid
    //     value: {}, // rowdata

    //   }
    // },
    ...mapState('user', ['roleName']),
    showFileColumn() {
      return Boolean(
        this.metaData?.config?.showFileColumn && this.showSettings.length && false,
      )
    },
    getEditor () {
      return row => {
        if (row.current_stage === '终止') {
          return true
        }
        
        return this.getSettings(row).find(item => item.command === 'update')
      }
    },
    getSettingsWidth() {
      let width = 20
      const step = 16
      const { settingsType } = this.tableProps
      if (['fund'].includes(this.$route.params.moduleInfoId)) {
        return 110
      }
      if (['Object_41ix__u'].includes(this.$route.params.moduleInfoId)) {
        return 100
      }
      if (['Sub_funds__u'].includes(this.$route.params.moduleInfoId)) {
        return 100
      }
      if (settingsType === 'dropdown') {
        width = 20
      } else {
        if (this.settings === 'inData') {
          if (this.tableData) {
            width = this.tableData.reduce((pre, item) => {
              if (item.menu) {
                let length = item.menu.reduce((pre1, item1) => {
                  return pre1 + item1.label.length
                }, 0)
                length = length * step + (item.menu.length - 1) * 10
                return length > pre ? length : pre
              }
              return pre
            }, 0)
          }
        } else {
          width =
            this.settings.reduce((pre, item) => {
              return pre + item.label.length * step
            }, 0) +
            (this.settings.length - 1) * 10
        }
      }
      return width + 20
    },
    gridOption() {
      const {
        selection,
        isSingle,
        supportMoveRow,
        moveRowKey,
      } = this.tableProps
      const option = {
        gridManagerName: this.gridManagerName,
        // loading: true,
        width: this.width,
        height: this.height,
        supportMenu: false,
        supportAutoOrder: false,
        supportDrag: false,
        supportAdjust: true,
        supportMoveRow: supportMoveRow || false,
        moveRowConfig: {
          fixed: 'right',
          key: moveRowKey,
          handler: (...arg) => {
            this.$emit('moveRowAfter', ...arg)
          },
        },
        supportCheckbox: selection,
        checkboxConfig: {
          useRadio: isSingle || this.isSingle,
          fixed: 'left',
        },
        sortDownText: 'desc',
        sortUpText: 'asc',
        checkedAfter: checkedList => {
          this.$emit('getSelectionRows', checkedList)
        },
        sortingAfter: query => {
          const key = Object.keys(query)[0]
          this.$emit('handleSort', {}, query[key], key)
        },
        handleFilter: (e, { key }) => {
          this.currentFilterEvent = e
          this.filterPopEvent = e
          if (this.filterMetas) {
            this.currentFilterProperty = key
            const forms = this.filterMetas[key]
            forms.property = key
            this.filterValue = {
              ...this.filterValues[this.currentFilterProperty],
            }
            this.filterForms = forms
          }
          if (this.filterPopVisible) {
            this.filterPopVisible = false
          } else {
            this.showPopover(e)
            this.filterPopEvent = false
          }
        },
        adjustAfter: (newWidth, oldWidth, col, e) => {
          col.property = col.key
          this.$emit('headerDragend', newWidth, oldWidth, col, e)
        },
        cellHover: this.cellHover,
        filterSubmit: this.handleFilterConfirmButton,
        filterReset: this.handleClearFilter,
        columnData: () => {
          const {
            headerData,
            showSettings,
            getSettingsWidth,
            showFileColumn,
            $route,
          } = this
          const {
            computeColumnDisplayName,
            computeTags,
          } = krTableDataMixin.methods
          const columnData = [...headerData]
          //const { favourite } = tableProps;
          // if (favourite) {
          //   columnData.unshift({
          //     label: '',
          //     type: 'FAVOURITE',
          //     value: 'favourite',
          //     width: 44,
          //     fixed: 'left',
          //   });
          // }
          if (supportMoveRow) {
            columnData.unshift({
              label: '',
              type: 'MOVE_ICOM',
              value: 'moveIcon',
              width: 40,
              fixed: 'left',
              align: 'center',
            })
          }
          if (columnData[0]?.width) {
            columnData[0].width = (parseFloat(columnData[0]?.width) + parseFloat(columnData[0]?.width) * 0.3) + 'px'
          }
          const columns = columnData.map(h => {
            const { value, width, type, fixed, sort, render, align, round } = h

            const column = {
              type,
              text: this.renderHeader(h),
              key: value,
              // 列宽：按 label 字数 + 按钮区算最小宽度，跟接口返回的 width 比取较大值；
              // 仅白名单业务对象（Object_41ix__u、Sub_funds__u）走此逻辑；
              // 其他业务对象不调工具函数，只用接口 width（无则走 136 默认值）。
              width: width || getColumnMinWidth(h.label, width, this.$route?.params?.moduleInfoId) || 136,
              fixed,
              align: align || getColumnAlignByType(type, this.$route?.params?.moduleInfoId),
              round,
              // filter: this.initFilter(value),
              // template: render || ((action, row, index, key, setParam)
              template: render
                ? this.renderColumn(h)
                : (...args) => {
                    const [action, row, index, key, setParam] = args
                    const { withTag, withColorTag, voteResult } =
                      row.status ?? {}
                    const withCustomColorTag = ''
                    let html = ''
                    if (type === 'MOVE_ICOM') {
                      html = `<i class="icon iconfont icon-drag" style="pointer-events: none"></i>`
                    } else if (type === 'object_reference') {
                      setParam({ row: (row[key] || [])[0] || {}, h })
                      html = `<span class="kr-table-link 44" @click="handelLink(row, h)">{{row.refFieldValue || row.label}}</span>`
                    } else if (type === 'multi_object_reference' && $route.params.moduleInfoId==='financial_summary') {
                      let linkHtml = ''
                      if(row && row[key] && row[key]?.length) {
                        row[key].forEach((item , i) => {
                          // setParam({row: item, h})
                          const link = `#/md/module/${item.targetApiName}/edit/${item.id}`
                          linkHtml += ` &nbsp; <a class="kr-table-link 55" href=${link} target='_black'>${item.refFieldValue || item.label}</a>`
                        })
                      }
                      html = linkHtml
                    } else if (type === 'select_one' && round) {
                      setParam({ row: (row[key] || [])[0] || {}, h })
                      html = `<span class="round ${this.color[row[key]]}"></span>`
                    } else if (this.getShowLink(h, row)) {
                      const text = computeColumnDisplayName.call(
                        this,
                        row[key],
                        key,
                        type,
                        row,
                        h,
                      )
                      setParam({ h, text })
                      const isQezq = ['fund'].includes(this.$route.params.moduleInfoId) && this.Global_qezq__global
                      if (text !== '-' && isQezq) {
                        html =  `<span class="22" title="${text}">{{ text }}</span>`
                      } else if (text !== '-' && !isQezq) {
                        html =  `<span class="kr-table-link 22" title="${text}" @click="handelLink(row, h)">{{ text }}</span>`
                      } else {
                        html = '-'
                      }
                    } else if (type === 'tag') {
                      let styleText
                      if (row[key] && row[key].length) {
                        html = `<span class="kr-table-tag">
                            ${computeTags
                              .call(this, row[key])
                              .reduce((pre, tag) => {
                                styleText = Boolean(tag.color)
                                  ? `background-color: ${
                                      tag.color ? tag.color : '#F2F4F6'
                                    }; color: #BE8C4B;`
                                  : ''
                                pre += `<div class="table-tag table-tag2" style="${styleText}">${tag.label}</div>`
                                return pre
                              }, '')}
                            </span>`
                      } else {
                        html = '-'
                      }
                    } else if (type === 'image' && row[key]) {
                      const text = row[key].imageName || ''
                      setParam({ text, img: row[key] })
                      html = `<span class="kr-table-link 77" title="${text}" @click="enterPreview($event, img)">{{ text }}</span>`
                    } else if (type === 'url' && row[key]) {
                      const text = row[key] || ''
                      setParam({ text })
                      const textUrl = text.split('|')
                      const textURL = textUrl[1] ? textUrl[1] : textUrl[0]
                      html = `<span class="kr-table-link 33" title="${text}" @click="handleURl(text)">${textURL}</span>`
                    } else {
                      const text = computeColumnDisplayName.call(
                        this,
                        row[value],
                        value,
                        type,
                        row,
                        h,
                      )
                      const isHtml = IS_HTML_REGEXP.test(text)
                      if (isHtml) {
                        html = text
                      } else {
                        html = `<span title="${text}">${text}</span>`
                      }
                    }

                    if (withTag) {
                      const targetstatus = row.status[`${key}___status`]
                      if (targetstatus) {
                        html += `<span class="${targetstatus.className}">${targetstatus.label}</span>`
                      }
                    }

                    if (withColorTag && key === 'vote_result') {
                      html = voteResult
                        .map(
                          ({ result, styleClass }) =>
                            `<span class="${styleClass}">${result}</span>`,
                        )
                        .join(',')
                    }

                    // if (type === 'FAVOURITE') {
                    // return `<i class="icon iconfont ${row.favourite ? 'icon-star-active' :
                    // 'icon-star'} favourite-icon" @click="favouriteClick($event, row)"></i>`;
                    // return `<i class="icon iconfont ${row.favourite ? 'icon-v_bookmark_filled' : 'icon-v_bookmark'} favourite-icon" @click="favouriteClick($event, row)"></i>`;
                    // }
                    return `${this.getBeforeTemp(
                      h,
                      row,
                    )}${html}${this.getAfterTemp(h, row)}`
                  },
            }

            // if (sort) {
            //   if (sort === 'asc' || sort === 'desc') {
            //     column.sorting = sort;
            //   } else {
            //     column.sorting = '';
            //   }
            // }

            return column
          })

          if (showFileColumn) {
            const column = {
              type: '',
              text: this.renderFileColumnHeader(),
              key: 'file',
              width: `120px`,
              align: 'center',
              fixed: 'right',
              template: this.renderFileColumn,
            }
            columns.push(column)
          }
          // p判断是否是 项目执行材料完备性复核功能的页面
          const iscCompleteReview = ['65d851616e343327e8a3f20d', '65dd9ef06e343326eda621f7'].includes(this.$route.params.menuCode)
          /**
           * @doc  https://rbnqidugqp.feishu.cn/wiki/ANVFwuKyVia600kBwG6cdPdynQh?table=tblXJDy1yYRLsNGn
           * 非LP本人创建的线索，最右侧操作不应该可以进入编辑弹窗进行编辑（查看页没问题，确实不能编辑）——“亦庄科创二期LP”角色的团队线索列表，去掉最后侧三点操作列
           * */ 
         
          const Object_be7l__u = ['Object_be7l__u'].includes(this.$route.params.moduleInfoId) && this.roleName == '亦庄科创二期LP'
          // 亦庄LP角色，基金列表-树状，最右侧操作列去掉；基金列表-平铺，最右侧操作列去掉
          const Global_qezq__global = ['fund'].includes(this.$route.params.moduleInfoId) && this.Global_qezq__global
          const yizhuangLp = this.roleName == '亦庄科创二期LP'

          if (showSettings && showSettings.length && !Object_be7l__u && !Global_qezq__global) {
            columns.push({
              type: '',
              text: this.renderSettingHeader(),
              key: 'operation',
              width: (yizhuangLp || this.operationLegalSupportTeam()) ? '110px' : `${getSettingsWidth}px`,
              align: 'center',
              fixed: 'right',
              disableCustomize: true,
              template: (action, row) => {
                if (['Object_41ix__u'].includes(this.$route.params.moduleInfoId)) {
                  // 亦庄LP角色，投前项目列表右侧只留一个按钮“查看”，跳转现在的编辑页面；投后项目列表右侧只留“投前”、“投后”两个按钮，跳转不变，去掉查看按钮
                  if (iscCompleteReview || this.jointVentureManagementRole) {
                    return `
                      <el-button style="padding: 0;" type="text" @click="toEdit(row)" v-if="Global_e4wl__global.operater.edit">编辑</el-button>
                    `
                  }
                  // 投后项目列表右侧只留“投前”、“投后”两个按钮，跳转不变，去掉查看按钮
                  if (row.Field_4s7t__u && row.Field_4s7t__u.length && yizhuangLp) {
                    return `
                      <el-button style="padding: 0;" type="text" @click="preInvestment(row)" v-if="Global_e4wl__global.operater.edit">投前</el-button>
                      <el-button style="padding: 0;" type="text" @click="toEdit(row)">投后</el-button>
                    `
                  } else if (row.Field_4s7t__u && row.Field_4s7t__u.length) {
                    /**
                      * @des 爱琳老师需求  调整需求：  20260120
                            1、希望直投、FOF项目的列表（包含一般列表、全局搜索）点击项目名称的时候，直接跳转项目编辑页面，查看按钮也去掉
                      * */ 
                    // <el-button style="padding: 0;" type="text" @click="toPreview(row)" v-if="Global_e4wl__global.operater.preview">查看</el-button>
                    return `
                      <el-button style="padding: 0;" type="text" @click="preInvestment(row)" v-if="Global_e4wl__global.operater.edit">投前</el-button>
                      <el-button style="padding: 0;" type="text" @click="toEdit(row)">投后</el-button>
                    `
                    // 亦庄LP角色，投前项目列表右侧只留一个按钮“查看”，跳转现在的编辑页面；
                  } else if (yizhuangLp) {
                    return `<el-button style="padding: 0;" type="text" @click="toEdit(row)" v-if="Global_e4wl__global.operater.edit">查看</el-button>`
                  } else {
                    /**
                     * @des 爱琳老师需求  调整需求：  20260120
                           1、希望直投、FOF项目的列表（包含一般列表、全局搜索）点击项目名称的时候，直接跳转项目编辑页面，查看按钮也去掉
                    * */ 
                    // <el-button style="padding: 0;" type="text" @click="toPreview(row)" v-if="Global_e4wl__global.operater.preview">查看</el-button>
                    return `
                      <el-button style="padding: 0;" type="text" @click="toEdit(row)" v-if="Global_e4wl__global.operater.edit">编辑</el-button>
                    `
                  }
                }
                if (iscCompleteReview) {
                  return `
                    <el-button style="padding: 0;" type="text" @click="toEdit(row)" v-if="Global_e4wl__global.operater.edit">编辑</el-button>
                  `
                }
                /**
                  * @des 爱琳老师需求  调整需求：  20260120
                        1、希望直投、FOF项目的列表（包含一般列表、全局搜索）点击项目名称的时候，直接跳转项目编辑页面，查看按钮也去掉
                * */ 
                // <el style="padding: 0;" type="text" @click="toPreview(row)" v -if= "Global_e4wl__global.operater.preview" > 查看</el - button >
                let viewAndEditBtns = this.jointVentureManagementRole ? 
                  `<el-button style="padding: 0;" type="text" @click="toEdit(row)" v-if="Global_e4wl__global.operater.edit">编辑</el-button>` :
                  `
                    
                    <el-button style="padding: 0;" type="text" @click="toEdit(row)" v-if="Global_e4wl__global.operater.edit">编辑</el-button>
                  `
                // https://rbnqidugqp.feishu.cn/wiki/P33twX7TciumHjkzysIc9daonlg
                // 备案信息维护》借用已有基金实体，进入台账默认恢复1.0版本，点【编辑】弹出弹窗，点查看跳转编辑页，编辑弹窗只展示基金名称+【合规事项】tab（操作栏改为可按角色配置），不再展示【查看】按钮
                if (this.operationLegalSupportTeam()) {
                  viewAndEditBtns = `<el-button style="padding: 0;" type="text" data-command="update" @click="handleSettings(row, $event)" v-if="Global_e4wl__global.operater.edit">编辑</el-button>`
                }

                if (['Object_1c98__u'].includes(this.$route.params.moduleInfoId) && this.operationLegalSupportTeam()) {
                  return viewAndEditBtns
                }

                if (['fund', 'Sub_funds__u'].includes(this.$route.params.moduleInfoId) && !['65791c2c0bbe2fbbc92be6db', '658d4cc637464ab4de565e3c', '658139b10bbe2fbbc92c40de', '658d4d31ff895028d6913411', '65700c656e3433c3e7344591', '656ffd146e3433c3e7344539'].includes(this.$route.params.menuCode)) {
                  return viewAndEditBtns
                }

                const settings = this.getSettings(row)
                if (settings.length) {
                  const { settingsType } = this.tableProps
                  if (settingsType === 'dropdown') {
                    return `<el-dropdown @command="handleSettings(row, ...arguments)">
                          <span style="cursor: pointer">
                          <i class="icon iconfont icon-more1 kr-table-setting-icon"></i>
                          </span>
                          <el-dropdown-menu slot="dropdown">
                          ${settings.reduce((pre, item) => {
                            pre += `<el-dropdown-item command='{ "key": "${item.command}" }'>
                                      ${item.label}
                                    </el-dropdown-item>`
                            return pre
                          }, '')}
                          </el-dropdown-menu>
                        </el-dropdown>`
                  }
                  if (VIEW_CODES.includes(row.code)) {
                    return `<div>${settings.reduce((pre, item) => {
                      if (item.command === 'edit') {
                        pre += `<el-button @click="handleSettings(row, $event)" data-command="${item.command}" type="text" style="padding: 0">${item.label}</el-button>`
                      } else {
                        pre += `<el-button @click="handleSettings(row, $event)" data-command="${item.command}" type="text" style="padding: 0;visibility:hidden">${item.label}</el-button>`
                      }
                      return pre
                    }, '')}</div>`
                  } else {
                    return `<div>${settings.reduce((pre, item) => {
                      pre += `<el-button @click="handleSettings(row, $event)" data-command="${item.command}" type="text" style="padding: 0">${item.label}</el-button>`
                      return pre
                    }, '')}</div>`
                  }
                }
                return ''
              },
            })
          }
          return columns
        },
        ajaxData: () => {
          return {
            data: this.tableData,
          }
        },
      }
      if (this.isProject) {
        option.fullColumn = {
          useFold: false,
          fixed: false, // 折叠事件列固定方向
          bottomTemplate: function(row, index) {
            return row.isShowChild
              ? `
                <div class="full-column__box">
                  <div class="full-column__content">
                    <div class="full-column__title">投前项目</div>
                    <related-table :row="row"/>
                  </div>
                </div>
              `
              : ''
          },
        }
      }
      return option
    },
    showSettings() {
      const { tableData, settings } = this
      let show = []
      if (settings === 'inData') {
        if (tableData.length > 0) {
          const item = tableData.find(d => {
            return d.menu && d.menu.length !== 0
          })
          show = (item && item.menu) || []
        } else {
          show = []
        }
      } else {
        show = settings
      }
      return show
    },
    isDateRangeType() {
      return this.DateRangeType
        ? this.DateRangeType
        : this.filterValue.dateRangeType
    },
    isProject() {
      return this.$route.params.moduleInfoId === 'project'
      // return false
    },
    jointVentureManagementRole() {
      const jointVentureManagementRoleCodes = ['66026d0c6e34337111f7f8ed', '660be61f0bbe2f2f5419e33f', '660bd18537464a324463f090'];
      return jointVentureManagementRoleCodes.includes(this.$store?.state?.user?.roleCode) || this.$store?.state?.user?.roloName === '合资管理';
    }
  },
  watch: {
    async headerData(val, old) {
      if (kr.script.compare(val, old)) {
        GridManager.refreshGrid(this.gridManagerName, false, () => {
          this.$emit('end')
        })
       this.$nextTick(()=> {
        setTimeout(()=> {
          const { tableData } = this
          // GridManager.resetLayout(tableData, '100% - 100px', '100%');
          // GridManager.setSort(tableData, {}, ()=> {}, true);
        }, 500)
       })
      } else {
        this.show = false
        this.$nextTick(() => {
          this.show = true
        })
      }
    },
    showSettings(val, old) {
      if (!kr.script.compare(val, old)) {
        this.show = false
        this.$nextTick(() => {
          this.show = true
        })
      }
    },
    height() {
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
  },
  methods: {
    toEdit (row) {
      const { id, Field_4s7t__u, current_stage } = row
      window.kr.sensors.track('aims_jump_details', {
        jumpSource: '旧项目详情', // 是否是新的项目详情 新项目详情 | 旧项目详情
        moduleInfoId: this.$route.params.moduleInfoId, // 当前实体名称
        entrySource: '列表编辑按钮', // 入口来源 列表项目名称、编号|列表查看|列表编辑
        projectname__u: row.projectname__u,
        name_u: row.name,
        menuCode: this.$route.params?.menuCode,
        router: ['65127dc56e3433470906fe3c', '6503d342825dda32abd64062', '6503d360825dda32abd64064', '6503d370825dda32abd64065', '6503d383825dda32abd64066'].includes(this.$route.params.menuCode) ? '首页' : '其他',
      })
      if (Field_4s7t__u && Field_4s7t__u.length) {
        const { object_describe_api_name, id } = Field_4s7t__u[0]
        
        this.$router.push({
          name: 'mdModuleEdit',
          params: {
            moduleInfoId: object_describe_api_name,
            id: id
          }
        })
      } else {
        const query = {}

        if (this.$route.params.moduleInfoId === 'Sub_funds__u' && ['投后管理', '结束'].includes(current_stage)) {
          query.layoutType = 'layout_two'
        }
        /**
         * @url https://rbnqidugqp.feishu.cn/wiki/KGXhwGPdniWMYkk1xRgclyyCn0S
         * @des 2. 审查台账 - （点击链接可进入项目编辑页——内控会环节）
         * */ 
        const { menuCode } = this.$route.params
        if(['65d851616e343327e8a3f20d', '65dd9ef06e343326eda621f7'].includes(menuCode)) {
          query.activeTabName = 'yewujieduan'
        }

        const router = {
          name: 'mdModuleEdit',
          params: {
            moduleInfoId: this.$route.params.moduleInfoId,
            id: id 
          },
          query: query
        }
        this.$router.push(router)
      }
    },
    toPreview (row) {
      const editor = this.getEditor(row)
      if (this.$route.params.moduleInfoId === 'Object_41ix__u') {
        const routeData = this.$router.resolve({ path: '/quankunLayout/project', query: { dataId: row.id, editor } })
        window.kr.sensors.track('aims_jump_details', {
          jumpSource: '新项目详情', // 是否是新的项目详情 新项目详情 | 旧项目详情
          moduleInfoId: this.$route.params.moduleInfoId, // 当前实体名称
          entrySource: '列表查看按钮', // 入口来源 列表项目名称、编号|列表查看
          projectname__u: row.projectname__u,
          name_u: row.name,
          menuCode: this.$route.params?.menuCode,
          router: ['65127dc56e3433470906fe3c', '6503d342825dda32abd64062', '6503d360825dda32abd64064', '6503d370825dda32abd64065', '6503d383825dda32abd64066'].includes(this.$route.params.menuCode) ? '首页' : '其他',
        })
        window.open(routeData.href, '_blank')
      } else if (this.$route.params.moduleInfoId === 'fund') {
        // 点击跳转2.0基金详情页默认定位到fundOverview（基金概览）组件页面
        sessionStorage.setItem('fundActiveTab', 'fundOverview');
        sessionStorage.setItem('fundInfoId', row.id)
        window.kr.sensors.track('aims_jump_details', {
          jumpSource: '新项目详情', // 是否是新的项目详情 新项目详情 | 旧项目详情
          moduleInfoId: this.$route.params.moduleInfoId, // 当前实体名称
          entrySource: '列表查看按钮', // 入口来源 列表项目名称、编号|列表查看
          projectname__u: row.projectname__u,
          name_u: row.name,
          menuCode: this.$route.params?.menuCode,
          router: ['65127dc56e3433470906fe3c', '6503d342825dda32abd64062', '6503d360825dda32abd64064', '6503d370825dda32abd64065', '6503d383825dda32abd64066'].includes(this.$route.params.menuCode) ? '首页' : '其他',
        })
        const routeData = this.$router.resolve({ path: '/quankunLayout/fundHome', query: { editor,'fundInfoId': row.id } })

        window.open(routeData.href, '_blank')
      } else if (this.$route.params.moduleInfoId === 'Sub_funds__u') {
        const routeData = this.$router.resolve({ path: `/quankunLayout/fof-details`, query: { dataId: row.id, editor } })

        window.open(routeData.href, '_blank')
      }
    },
    renderFileColumn(action, row) {
      return `<el-button style="padding: 0;" type="text" @click="handleShowFileListDialog(row, $event)">文件汇总</el-button>`
      // if(['Object_41ix__u'].includes(this.$route.params.moduleInfoId)) {
      //   const isDisabled = row?.Field_4s7t__u?.length ? false : true
      //   return `
      //     <el-button style="padding: 0;" type="text" @click="preInvestment(row, $event)">投前</el-button>
      //     <el-button style="padding: 0;" type="text" @click="afterInvestment(row, $event)" :disabled="${isDisabled}">投后</el-button>
      //   `
      // }
    },
    // 文件汇总弹框
    async handleShowFileListDialog(row, evt) {
      const params = {
        apiName: this.metaData.apiName,
        id: row.id,
      }
      const rs = await queryAllFileList({
        data: {
          objectDescribeApiName: params.apiName,
          dataId: params.id,
        },
      })
      const data = rs?.data?.tableData || []
      this.viewFileConfig = {
        ...this.viewFileConfig,
        ...params,
        value: row,
        obj: {
          value: {
            fileType: data.map(type => {
              return {
                ...type,
                apiName: type.file_type_api_name,
                label: type.file_type,
              }
            }),
          },
        },
      }
      this.viewFileDialog = {
        ...this.viewFileDialog,
        visible: true,
      }
    },
    // 投前
    preInvestment(row) {
      window.kr.sensors.track('aims_jump_details', {
        jumpSource: '旧项目详情', // 是否是新的项目详情 新项目详情 | 旧项目详情
        moduleInfoId: this.$route.params.moduleInfoId, // 当前实体名称
        entrySource: '列表投前按钮', // 入口来源 列表项目名称、编号|列表查看|列表编辑|列表投前
        projectname__u: row.projectname__u,
        name_u: row.name,
        menuCode: this.$route.params?.menuCode,
        router: ['65127dc56e3433470906fe3c', '6503d342825dda32abd64062', '6503d360825dda32abd64064', '6503d370825dda32abd64065', '6503d383825dda32abd64066'].includes(this.$route.params.menuCode) ? '首页' : '其他',
      })
      this.$router.push({
        path: `/md/module/Object_41ix__u/edit/${row.id}`,
        query: {
          _t_: Date.now(),
        },
      })
    },
    // 投后
    afterInvestment(row) {
      window.kr.sensors.track('aims_jump_details', {
        jumpSource: '旧项目详情', // 是否是新的项目详情 新项目详情 | 旧项目详情
        moduleInfoId: row.Field_4s7t__u[0].targetApiName, // 当前实体名称
        entrySource: '列表投后按钮', // 入口来源 列表项目名称、编号|列表查看|列表编辑|列表投前
        projectname__u: row.projectname__u,
        name_u: row.name,
        menuCode: this.$route.params?.menuCode,
        router: ['65127dc56e3433470906fe3c', '6503d342825dda32abd64062', '6503d360825dda32abd64064', '6503d370825dda32abd64065', '6503d383825dda32abd64066'].includes(this.$route.params.menuCode) ? '首页' : '其他',
      })
      this.$router.push({
        path: `/md/module/${row.Field_4s7t__u[0].targetApiName}/edit/${row.Field_4s7t__u[0].id}`,
        query: {
          _t_: Date.now(),
        },
      })
    },
    formatDate(type) {
      let startTime, endTime
      if (type == 'week') {
        startTime = moment()
          .startOf('week')
          .add(1, 'day')
          .valueOf() //国外一周从周日算起，所以加1天
        endTime = moment()
          .endOf('week')
          .subtract(1, 'day')
          .valueOf() //我们需要周一到周五
        return [startTime, endTime]
      }
      startTime = moment(
        moment()
          .week(moment().week())
          .startOf(type)
          .valueOf(),
      ).valueOf()
      endTime = moment(
        moment()
          .week(moment().week())
          .endOf(type)
          .valueOf(),
      ).valueOf()
      return [startTime, endTime]
    },
    DateCateBtnTypeHandle(type) {
      let filterValue = this.formatDate(type)
      this.$set(this.filterValue, 'value', filterValue)
      this.DateRangeType = type
    },
    ...krTableDataMixin.methods,
    clearSelection() {
      GridManager.setCheckedData(this.gridManagerName, [])
    },
    getStyle:
      Number(document.documentMode) < 9
        ? function(element, styleName) {
            if (!element || !styleName) return null
            styleName = camelCase(styleName)
            if (styleName === 'float') {
              styleName = 'styleFloat'
            }
            try {
              switch (styleName) {
                case 'opacity':
                  try {
                    return element.filters.item('alpha').opacity / 100
                  } catch (e) {
                    return 1.0
                  }
                default:
                  return element.style[styleName] || element.currentStyle
                    ? element.currentStyle[styleName]
                    : null
              }
            } catch (e) {
              return element.style[styleName]
            }
          }
        : function(element, styleName) {
            if (!element || !styleName) return null
            styleName = camelCase(styleName)
            if (styleName === 'float') {
              styleName = 'cssFloat'
            }
            try {
              const computed = document.defaultView.getComputedStyle(
                element,
                '',
              )
              return element.style[styleName] || computed
                ? computed[styleName]
                : null
            } catch (e) {
              return element.style[styleName]
            }
          },
    cellLeave(e) {
      const tooltip = this.$refs.tooltip
      if (tooltip) {
        tooltip.setExpectedState(false)
        tooltip.handleClosePopper()
      }
      e.target.removeEventListener('mouseleave', this.cellLeave)
    },
    cellHover(td, { type = null, key } = {}, row) {
      const range = document.createRange()
      range.setStart(td, 0)
      range.setEnd(td, td.childNodes.length)
      const rangeWidth = range.getBoundingClientRect().width
      let padding = parseInt(this.getStyle(td, 'paddingLeft'), 10) || 0
      padding += (parseInt(this.getStyle(td, 'paddingRight'), 10) || 0) + 1
      if (
        rangeWidth + padding > td.offsetWidth ||
        td.scrollWidth > td.offsetWidth
      ) {
        if (this.$refs.tooltip) {
          if (type === 'long_text') {
            this.tooltipContent = row[key]
            this.tooltipContent = this.tooltipContent.replace(
              /\n|\r\n/g,
              '<br/>',
            )
          } else if (['select_many', 'select_one'].includes(type)) {
            this.tooltipContent = td.innerHTML || td.innerText || td.textContent
          } else {
            this.tooltipContent = td.innerText || td.textContent
          }
          this.tooltipContent = (this.tooltipContent || '').split('<br/>')
          this.tooltipContent = this.tooltipContent.reduce(
            (pre, item, index) => {
              pre.push(`<span>${item}</span>`)
              if (index < this.tooltipContent.length - 1) {
                pre.push('<br/>')
              }
              return pre
            },
            [],
          )

          const tooltip = this.$refs.tooltip
          tooltip.referenceElm = td
          if (tooltip.$refs.popper) {
            tooltip.$refs.popper.style.display = 'none'
          }
          tooltip.doDestroy()
          tooltip.$slots.content = this.tooltipContent
          tooltip.appended = false
          tooltip.setExpectedState(true)
          this.activateTooltip(tooltip)
          td.addEventListener('mouseleave', this.cellLeave)
        }
      }
    },
    getBeforeTemp({ value }, row) {
      const { favourite } = this.tableProps
      let htmlStr = ''
      if (this.isProject && value === 'name') {
        htmlStr += `<i style="color: '#9699AC'" class="iconfont icon-tree-${
          row.isShowChild ? 'close' : 'open'
        } tree-icon" @click="toggleTree($event, row, index)"></i>`
      }
      if (favourite && value === 'name') {
        htmlStr += `<i style="color: '#9699AC'" class="icon iconfont ${
          row.favourite ? 'icon-v_bookmark_filled' : 'icon-v_bookmark'
        } favourite-icon" @click="favouriteClick($event, row)"></i>`
      }
      return htmlStr
    },
    getAfterTemp({ value }, row) {
      if (
        value === 'name' &&
        row.object_describe_api_name !== 'risk' &&
        row.risk_status &&
        row.risk_status !== 'null'
      ) {
        return `<i class="icon iconfont icon-alert-active ${
          row.risk_status === 'triggered' ? 'alert-icon-active' : 'alert-icon'
        }"></i>`
      }
      return ''
    },
    handleURl(url) {
      window.open(this.computeUrl(url))
    },
    async toggleTree(e, row, index) {
      if (!row.relatedResult) {
        const result = await getRecordTypeLayout({
          data: {
            moduleInfoId: this.$route.params.moduleInfoId,
            recordType: row.record_type,
          }
        })
        const filterOuter = result.layout.sections.tabs.find(element => {
          return element.children.find(item => {
            return (
              item.ele === 'related' &&
              item.obj.value.relatedDataFrom.objectDescribeApiName ===
                'Object_41ix__u'
            )
          })
        })
        if (!filterOuter) {
          this.$message.error('请先配置相关项');
          return
        }
        const element = filterOuter.children.find(item => {
          return (
            item.ele === 'related' &&
            item.obj.value.relatedDataFrom.objectDescribeApiName ===
              'Object_41ix__u'
          )
        })
        const relatedResult = await relatedDataByReference({
          data: {
            targetDescribeApiName: 'Object_41ix__u', // 仅展示投前相关项
            apiName: 'project',
            dataId: row.id,
            relatedListName:
              element.obj.value.relatedDataFrom.targetRelatedListName,
            scene: element.obj.random,
            filters: [],
            orders: [],
            pattern: '',
            layoutApiName: '',
          },
        })
        relatedResult.data.headerData.forEach(element => {
          element.sort = false
        })
        this.tableData[index].relatedResult = relatedResult
      }
      this.tableData[index].isShowChild = !row.isShowChild
      GridManager.refreshGrid(this.gridManagerName, false)
      const { tableData } = this
      GridManager.setSort(tableData, {}, ()=> {}, true);


      // this.loading = false
    },
    favouriteClick(e, row) {
      row.favourite = !row.favourite
      this.$emit('favouriteClick', e, row)
    },
    async handleClearFilter(e, callback) {
      this.filterValues[this.currentFilterProperty] = ''
      this.filterValue = ''
      this.$nextTick(async () => {
        const { filterForms } = this.$refs
        const value = await filterForms.submit()
        this.$emit('onFilter', value)
        this.filterPopVisible = false
        callback(this.currentFilterEvent, this.currentFilterProperty, {})
      })
    },
    async handleFilterConfirmButton(e, callback) {
      const { filterForms } = this.$refs
      const value = await filterForms.submit()
      value.dateRangeType = this.DateRangeType
      this.filterPopVisible = false
      this.$set(this.filterValues, this.currentFilterProperty, value)
      this.$emit('onFilter', value)
      callback(this.currentFilterEvent, this.currentFilterProperty, value)
    },
    showPopover(e) {
      this.$nextTick(() => {
        const target = e.target.parentElement.parentElement.parentElement
        this.$refs.popover.referenceElm = target
        this.reference = target
        this.filterPopVisible = true
      })
    },
    popoverAfterLeave() {
      if (this.filterPopEvent) {
        this.showPopover(this.filterPopEvent)
      }
      this.filterPopEvent = false
      this.DateRangeType = ''
    },
    getFilterMeta(val) {
      return this.filterMetas && this.filterMetas[val]
    },
    sortChange(...arg) {
      this.$emit('sort-change', ...arg)
    },
    renderHeader(h) {
      const { renderHeader, label, value } = h
      let meta = this.metaData.fields || {}
      meta = meta[value] || {}
      const { tableStore } = this
      return setParam => {
        const filterMeta = this.getFilterMeta(value)
        // 给 th 组件补一个 align 字段：接口返回的 headerData[i].align 通常是 undefined，
        // 这里按 type 推导（数字/百分比/货币 -> right），供 krThByGm 切换 flex 布局用。
        // 用浅拷贝避免污染 headerData 原始数据。
        setParam({
          h: { ...h, align: getColumnAlignByType(h.type, this.$route?.params?.moduleInfoId) },
          meta,
          filterMeta,
          tableStore,
        })
        return `<kr-th-by-gm :meta="meta" :table-store="tableStore" :filter-meta="filterMeta" :col="h" @sort-change="sortChange">${
          renderHeader ? renderHeader(h) : label
        }</kr-th-by-gm>`
      }
    },

    renderColumn(col) {
      return (action, row, index, key, setParam) => {
        setParam({ col, scope: { $index: index, row } })
        return `<run-template v-if="col.template || col.render" :template="col.template" :render="(col.render || (() => {}))(col, scope)"></run-template>`
      }
    },
    // 法律支持组判断
    operationLegalSupportTeam() {
     return this.roleName == '运营法律支持组' && ['Object_1c98__u', 'fund'].includes(this.$route.params.moduleInfoId) 
    },
    renderSettingHeader() {
      const { renderSetHeader } = this
      if (renderSetHeader) {
        return renderSetHeader()
      }
      const { settingsType } = this.tableProps
      return `<span
                  style="display: flex;
                  flex-grow: 1;
                  place-content: center;
                  align-items: center;
                ">
                  ${
                    settingsType === 'dropdown'
                      ? '<i class="icon iconfont icon-shezhi-xian" style="cursor: pointer; color: #9699ac" @click="handleSetting"></i>'
                      : '操作'
                  }
                </span>`
    },
    renderFileColumnHeader() {
      return `<span
                  style="
                    display: flex;
                    flex-grow: 1;
                    place-content: center;
                    align-items: center;
                  "
                >
                  <i class="el-icon-folder-opened" style="color: #9699ac"></i>
                </span>`
    },
    handleSetting() {
      this.$emit('handleSetHeader')
    },
    getQuery(row) {
      let { query } = this
      if (Array.isArray(query)) {
        query = query.reduce((per, item) => {
          per[item] = row[item]
          return per
        }, {})
        return query
      }
      return {}
    },
    compatibleLink(row, item, link) {
      window.kr.sensors.track('aims_jump_details', {
        jumpSource: '旧项目详情', // 是否是新的项目详情 新项目详情 | 旧项目详情
        moduleInfoId: this.$route.params.moduleInfoId, // 当前实体名称
        entrySource: '列表项目名称、编号', // 入口来源 列表项目名称、编号|列表查看|列表编辑|列表投前
        projectname__u: row?.pjname__u,
        name_u: row?.name,
        menuCode: this.$route.params?.menuCode,
        router: ['65127dc56e3433470906fe3c', '6503d342825dda32abd64062', '6503d360825dda32abd64064', '6503d370825dda32abd64065', '6503d383825dda32abd64066'].includes(this.$route.params.menuCode) ? '首页' : '其他',
      })
      const url = this.$kr.url.inject(
        link + (row[item.codeAttr] ? `/${row[item.codeAttr]}` : ''),
        this.$route.params,
        this.getQuery(row),
      )
      // if (target) {
      //   const routeData = this.$router.resolve(url);
      //   window.open(routeData.href, '_blank');
      //   return;
      // }
      this.$tagRouter.push({
        path: url,
      })
    },
    handelLink(row, h) {
      let link = row.link || h.link
      let targetBlank = false
      const yizhuangLp = this.roleName == '亦庄科创二期LP'
      if (this.Global_e4wl__global.operater.preview) {
        if (['Object_41ix__u', 'Sub_funds__u'].includes(this.$route.params.moduleInfoId) && ['projectname__u', 'pjname__u', 'name'].includes(h.value)) {
          if (!this.jointVentureManagementRole && this.$route.params.moduleInfoId === 'Object_41ix__u') {
            /**
             * @des 爱琳老师需求  调整需求：  20260120
                    1、希望直投、FOF项目的列表（包含一般列表、全局搜索）点击项目名称的时候，直接跳转项目编辑页面
             * */ 
            // link = `/quankunLayout/project?dataId=${row.id}`
            // // 跳转详情埋点（区分新页面|旧页面）
            // window.kr.sensors.track('aims_jump_details', {
            //   jumpSource: '新项目详情',
            //   moduleInfoId: this.$route.params.moduleInfoId,
            //   entrySource: '列表项目名称、编号',
            //   projectname__u: row.projectname__u,
            //   name_u: row.name,
            //   router: ['65127dc56e3433470906fe3c', '6503d342825dda32abd64062', '6503d360825dda32abd64064', '6503d370825dda32abd64065', '6503d383825dda32abd64066'].includes(this.$route.params.menuCode) ? '首页' : '其他',
            // })
            // targetBlank = true
          } else if (this.$route.params.moduleInfoId === 'Sub_funds__u') {
            /**
             * @des 爱琳老师需求  调整需求：  20260120
                    1、希望直投、FOF项目的列表（包含一般列表、全局搜索）点击项目名称的时候，直接跳转项目编辑页面
            * */ 
            // if (!['65700c656e3433c3e7344591', '656ffd146e3433c3e7344539', '658d4cc637464ab4de565e3c', '65791c2c0bbe2fbbc92be6db'].includes(this.$route.params.menuCode)) {
            //   targetBlank = true
              
            //   link = `/quankunLayout/fof-details?dataId=${row.id}`
            // }
          }
        } else if (!this.jointVentureManagementRole && (this.$route.params.moduleInfoId === 'fund' && h.value === 'name' || ['Object_41ix__u', 'Sub_funds__u'].includes(this.$route.params.moduleInfoId) && h.value === "Field_fundfullname__u")) {
          if (!yizhuangLp && !['658d4cc637464ab4de565e3c', '658d4d31ff895028d6913411', '65700c656e3433c3e7344591', '656ffd146e3433c3e7344539', '658139b10bbe2fbbc92c40de', '65791c2c0bbe2fbbc92be6db'].includes(this.$route.params.menuCode)) {
            // 点击跳转2.0基金详情页默认定位到fundOverview（基金概览）组件页面
            sessionStorage.setItem('fundActiveTab', 'fundOverview');
            sessionStorage.setItem('fundInfoId', row.value || row.id)

            link = `/quankunLayout/fundHome?fundInfoId=${row.value || row.id}`
            window.kr.sensors.track('aims_jump_details', {
              jumpSource: '新项目详情', // 是否是新的项目详情 新项目详情 | 旧项目详情
              moduleInfoId: this.$route.params.moduleInfoId, // 当前实体名称
              entrySource: '列表项目名称、编号', // 入口来源 列表项目名称、编号|
              projectname__u: row.projectname__u,
              name_u: row.name,
              router: ['65127dc56e3433470906fe3c', '6503d342825dda32abd64062', '6503d360825dda32abd64064', '6503d370825dda32abd64065', '6503d383825dda32abd64066'].includes(this.$route.params.menuCode) ? '首页' : '其他',
              menuCode: this.$route.params?.menuCode,
            })
            targetBlank = true
          }
        }
      }
      // 定制化开发核心财务指标关联基金点击可以跳转
      if (h.type == 'multi_object_reference' && this.$route.params.moduleInfoId === 'financial_summary' && ['fund__u'].includes(h.value)) {
        link = `#/md/module/${row.targetApiName}/edit/${row.id}`
        window.open(link, '_blank')
        return false
      }
      // const target = h.target === '_blank';
      // 兼容codeAttr写法，填自己挖的坑，codeAttr 已废弃 不允许再使用
      if (h.codeAttr) {
        this.compatibleLink(row, h, link)
      } else {
        link = kr.replaceUrl(link, row)
        const { moduleInfoId } = this.$route.params
        window.kr.sensors.track('aims_jump_details', {
          jumpSource: '旧项目详情', // 是否是新的项目详情 新项目详情 | 旧项目详情
          moduleInfoId: moduleInfoId, // 当前实体名称
          entrySource: '列表项目名称、编号', // 入口来源 列表项目名称、编号|列表查看|列表编辑|列表投前
          projectname__u: row?.pjname__u,
          name_u: row?.name,
          menuCode: this.$route.params?.menuCode,
          router: ['65127dc56e3433470906fe3c', '6503d342825dda32abd64062', '6503d360825dda32abd64064', '6503d370825dda32abd64065', '6503d383825dda32abd64066'].includes(this.$route.params.menuCode) ? '首页' : '其他',
        })
        // const { moduleInfoId } = this.$route.params
        // if (moduleInfoId === 'report_entity__u' && h.value === 'name' && h.type === 'auto_number') {
        //   this.$tagRouter.push({
        //     path: link,
        //     query: { first: row.all || '', second: row.tid || '' }
        //   })
        //   return
        // }
        if (targetBlank) {
          const url = this.$router.resolve({
            path: link,
            query: {
              editor: this.getEditor(row)
            }
          })

          window.open(url.href, '_blank')
        } else {
          this.$tagRouter.push({
            path: link,
          })
        }
      }
    },
    getShowLink(item, row) {
      // if (row.Field_4s7t__u && row.Field_4s7t__u.length) {
      //   return false
      // }
      const disabledField = ['name', 'projectname__u']
      const yizhuangLp = this.roleName == '亦庄科创二期LP'
      if (disabledField.includes(item.value) && yizhuangLp) {
        return false
      }
      
      if (item.link && row[item.value]) {
        return true
      }
      if (item.isLink && row.link) {
        return true
      }
      return false
    },
    handleSettings(row, e) {
      let command = ''
      if (e.target) {
        command =
          e.target.dataset.command || e.target.parentElement.dataset.command
      } else {
        command = JSON.parse(e).key
      }
      this.$emit('settingsClick', { row, key: command })
    },
    getSettings(row) {
      return (this.settings === 'inData' ? row.menu : this.settings) || []
    },
    callback() {
      this.$emit('end')
    },
    async globalVariableList () {
      const globalVariable = await globalVariableList({
        data: {
          currentPage: 1,
          pageSize: 10000000
        }
      })

      this.Global_e4wl__global = JSON.parse(globalVariable.data.find(item => item.apiName === 'Global_e4wl__global').value)
        .find(item => item.roleName === this.roleName)

      // const qezq = JSON.parse(globalVariable.data.find(item => item.apiName === 'Global_qezq__global').value) || []
      // this.Global_qezq__global = qezq?.map(item => item.name).includes(this.roleName)
      this.Global_qezq__global = ['亦庄科创二期LP'].includes(this.roleName)
      if (this.Global_e4wl__global === undefined) {
        this.Global_e4wl__global = { "roleName": "管理员", "operater": { "edit": true, "preview": true} }
      }                            
    }
  },
  created() {
    this.globalVariableList()

    this.activateTooltip = _.debounce(tooltip => tooltip.handleShowPopper(), 50)
  },
  mounted() {
    window.kr.bus.$on('ChangeEmptydateRangeType', () => {
      this.filterValue.dateRangeType = ''
      this.DateRangeType = ''
    })
  },
  beforeDestroy() {
    window.kr.bus.$off('ChangeEmptydateRangeType')
  },
  components: {
    krThByGm,
    GridManager,
    tableFilterForm: () => import('../form/view/tableFilterForm'),
    Preview: () => import('../krPreviewImage'),
    KrDialog,
    ViewFile: () =>
      import('@inv/view/metaData/module/components/file/index.vue'),
    runTemplate,
    RelatedTable,
    ...fields
  },
}
</script>

<style lang="scss" scoped>
.file-content {
  padding-top: 20px;
}
</style>

<style lang="scss">
.pending {
  border: 1px solid orange !important;
  font-size: 12px !important;
  color: orange !important;
  padding: 0 2px !important;
  margin-left: 5px;
  display: inline-block;
}

.completed {
  border: 1px solid rgba(8, 136, 8, 0.89) !important;
  font-size: 12px !important;
  color: rgba(8, 136, 8, 0.89) !important;
  padding: 0 2px !important;
  margin-left: 5px;
  display: inline-block;
}

.timeOut {
  background-color: red !important;
  font-size: 12px !important;
  color: #fff !important;
  padding: 0 2px !important;
  margin-left: 5px;
  display: inline-block;
}

.EarlyWarning {
  border: 1px solid red !important;
  font-size: 12px !important;
  color: red !important;
  padding: 0 2px !important;
  margin-left: 5px;
  display: inline-block;
}

.kr-table-by-gm {
  margin-top: 10px;

  /* .gm-menu ::-webkit-scrollbar-thumb, .table-wrap ::-webkit-scrollbar-thumb { */

  /* } */

  .gm-menu,
  .table-wrap {
    line-height: 1.3;
  }

  .kr-table-setting-icon::before {
    color: #BE8C4B;
  }

  .gm-icon-filter.filter-selected::before {
    color: #D89F55;
  }

  [gm-checkbox][th-name] .th-wrap {
    padding: 0 !important;
  }
  .round {
    width: 22px;
    height: 22px;
    display: inline-block;
    border-radius: 22px;
    margin: 5px 0 0 10px;
  }
  .red {
    background: #9F492D;
  }
  .yellow {
    background: #BE8C4B;
  }
  .blue {
    background: #215596;
  }
  .green {
    background: #27923E;
  }

  .table-wrap {
    border: 1px solid #e4e5eb;

    tbody tr:hover td {
      background-color: #f9fafc !important;
    }

    .gm-dreamland-div th[sorting][filter] .th-text,
    [grid-manager] th[sorting][filter] .th-text {
      width: calc(100% - 40px);
    }

    .gm-dreamland-div th[filter] .th-text,
    [grid-manager] th[filter] .th-text {
      width: calc(100% - 20px);
    }

    [gm-checkbox][th-name] .th-wrap .th-text {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .gm-dreamland-div th[sorting] .th-text,
    [grid-manager] th[sorting] .th-text {
      width: calc(100% - 20px);
    }

    .gm-checkbox-checked .gm-checkbox-inner,
    .gm-checkbox-indeterminate .gm-checkbox-inner {
      background-color: #D89F55;
      border-color: #D89F55;
    }

    .gm-checkbox-checked::after {
      border-color: #D89F55;
    }

    .gm-checkbox-checked .gm-checkbox-inner::after {
      border: 1px solid #fff;
      border-top: 0;
      border-left: 0;
    }

    .table-header {
      background: #f9fafc;
    }

    [gm-overflow-x='true'] [grid-manager-mock-thead] [fixed] {
      background: #f9fafc;
      background: linear-gradient(180deg, #FAF6F1 39%, #FDF1E0 100%);
    }

    [gm-overflow-x=true] [grid-manager-mock-thead] [fixed]:last-child:after {
      background: #f9fafc;
    }

    .th-wrap {
      height: 30px;
      padding: 0 6px !important;

      /* padding-right: 11px !important; */

      .th-text {
        /* display: inline-block; */
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #333b44;
        display: flex;
        flex-grow: 1;
      }
    }

    tbody tr:nth-child(odd) td {
      background-color: #fff;
    }

    td {
      padding-top: 5px !important;
      padding-bottom: 4px !important;
      font-family: PingFangSC-Regular;
      font-size: 14px;

      > span {
        color: #333b44;
        letter-spacing: 0;
        line-height: 20px;
      }
    }
    tr[full-column],
    tr[full-column-interval] {
      > td {
        padding-top: 0px !important;
        padding-bottom: 0px !important;
        .full-column-div {
          background: #f9fafc;
        }
        .full-column__box {
          width: 100%;
          border-top: 1px solid #e4e5eb;
        }
        .full-column {
          &__content {
            width: 1102px;
            padding: 16px 42px 16px 42px;
            font-size: 0;
            tr,
            th {
              padding: 0 !important;
            }
            td {
              border-right: 1px solid #e4e5eb;
              border-bottom: 1px solid #e4e5eb;
              background: #fff;
            }
            .el-table {
              border-left: 1px solid #e4e5eb;
              border-top: 1px solid #e4e5eb;
              tbody tr td {
                position: relative !important;
                left: 0 !important;
                box-shadow: none;
              }
            }
            .kr-table {
              margin-top: -2px;
            }
          }
          &__title {
            font-size: 14px;
            color: #333b44;
            margin-bottom: 8px;
          }
        }
      }
    }

    .kr-table-link {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #D89F55;
      letter-spacing: 0;
      line-height: 20px;
      cursor: pointer;
    }

    .kr-table-tag {
      display: flex;

      .table-tag {
        // background: #f6f7fb;
        border-radius: 4px;
        font-size: 14px;
        color: #333b44;
        line-height: 24px;
        padding: 0 6px;
        margin-right: 8px;
      }
      .table-tag2 {
        padding: 0 6px;
        height: 24px;
        line-height: 24px;
        border-radius: 4px;
        border: 1px solid rgba(0, 0, 0, 0.08);
        background: #f2f4f6;
      }
    }
  }

  thead {
    vertical-align: middle !important;

    tr,
    th {
      height: 32px !important;
      vertical-align: middle !important;
      background: linear-gradient(180deg, #FAF6F1 39%, #FDF1E0 100%);
    }
  }
  .tree-icon {
    color: #959aa2;
    cursor: pointer;
    font-size: 16px;
    margin-right: 8px;
  }
  .favourite-icon {
    margin-right: 4px;
    cursor: pointer;
  }

  .alert-icon-active {
    margin-left: 5px;
    color: #f45e72;
  }
}

.filterBox {
  .btnGloupClass {
    width: 100%;
    display: flex;
    justify-content: space-around;
  }

  & /deep/ .el-form {
    padding: 0 0 10px 0;
  }
}

.kr-table-by-gm .table-wrap tbody tr:hover td {
  background: #fff !important;
}

.table-wrap td[col-key='operation'] {
  border-right: 0;
  position: relative;
}
.kr-table-by-gm .table-wrap [gm-overflow-x=true] [grid-manager-mock-thead] [fixed]:last-child:after {
  background: linear-gradient(180deg, #FAF6F1 39%, #FDF1E0 100%)!important;
}
.table-wrap tr [last-visible]::before {
  content: '';
  position: absolute;
  width: 9px;
  height: 100%;
  left: -5px;
  background: linear-gradient(180deg, #FAF6F1 39%, #FDF1E0 100%);
  box-shadow: rgb(228, 229, 235) -2px 1px 3px;
}
.text-nowrap  {
  white-space: nowrap;
  .el-loading-text {
    margin-left: 36px;
  }
}
</style>
